/**
 * How old a dataset's data is, as a coloured age.
 *
 * Used by the datasets list (per dataset) and by the team attach card (for
 * the dataset a team is about to apply). The clock and the thresholds live
 * in `./staleness`.
 */

import { cn } from '@lean-agility/design-system/react';

import type { LatestIngestionResponse } from '../types';
import { formatAge, stalenessTone, useNow, type StalenessTone } from './staleness';

const TONE_CLASS: Record<StalenessTone, string> = {
  success: 'bg-feedback-success/10 text-feedback-success',
  warning: 'bg-feedback-warning/10 text-feedback-warning',
  error: 'bg-feedback-error/10 text-feedback-error',
};

export function StalenessBadge({ syncState }: { syncState: LatestIngestionResponse | null }) {
  const now = useNow();
  const lastSuccessAt = syncState?.last_success_completed_at ?? null;
  if (!lastSuccessAt) {
    return (
      <span className="inline-flex items-center rounded-sm bg-bg-muted px-2 py-0.5 text-xs text-text-muted">
        never synced
      </span>
    );
  }
  const ageMs = now - new Date(lastSuccessAt).getTime();
  return (
    <span className={cn('inline-flex items-center rounded-sm px-2 py-0.5 text-xs', TONE_CLASS[stalenessTone(ageMs)])}>
      {formatAge(ageMs)}
    </span>
  );
}
